import { useEffect, useState } from "react";
import {
  GoogleMap,
  Marker,
  InfoWindow,
  useLoadScript
} from "@react-google-maps/api";
import { MAPS_API_KEY } from "../../../../components/mapKey";
import { useRef } from "react";
import { decryptToken } from "../../../../Utlis/Encryption";
import { BASE_URL } from "../../../../components/BaseUrl";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../../components/CustomButton";
import CloseIcon from "@mui/icons-material/Close";

const TrialClientsPins = ({ 
    selectedClientId,
  onClearClientId,
  filters,
  page,
  limit,
  search,
 }) => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
const {t} =useTranslation()





const { isLoaded } = useLoadScript({
  googleMapsApiKey: MAPS_API_KEY,
});

const mapRef = useRef(null);
const [selectedMarker, setSelectedMarker] = useState(null);


const getStatusIcon = (status) => {
  let url = "";

  switch (status) {
    case "invited":
      url = "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-blue.png";
      break;
    case "requested":
      url = "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-gold.png";
      break;
    case "active":
      url = "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png";
      break;
    case "inactive":
      url = "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png";
      break;
    default:
      url = "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png";
  }

  return {
    url,
    scaledSize: new window.google.maps.Size(25, 41),
    anchor: new window.google.maps.Point(12, 41),
  };
};


  const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;
useEffect(() => {
  setLoading(true);

  const params = new URLSearchParams({
    page: page + 1,          // API is 1-based
    limit: limit,
    sort_by: "created_at",
    sort_order: "DESC",
  });

  if (search) params.append("search", search);
  if (filters?.verification_status && filters.verification_status !== "all") {
    params.append("verification_status", filters.verification_status);
  }

  if (filters?.status) {
    params.append("status", filters.status);
  }

  if (filters?.start_date) {
    params.append("start_date", filters.start_date);
  }

  if (filters?.end_date) {
    params.append("end_date", filters.end_date);
  }
  if (filters?.country) {
  params.append("country", filters.country);
}
if (filters?.state) {
  params.append("state", filters.state);
}

if (filters?.city) {
  params.append("city", filters.city);
}
if (filters?.subscription_status) {
  params.append(
    "subscription_status",
    filters.subscription_status
  );
}

if (filters?.trial_end_date_from) {
  params.append(
    "trial_end_date_from",
    filters.trial_end_date_from
  );
}

if (filters?.trial_end_date_to) {
  params.append(
    "trial_end_date_to",
    filters.trial_end_date_to
  );
}

if (filters?.subscription_start_date_from) {
  params.append(
    "subscription_start_date_from",
    filters.subscription_start_date_from
  );
}

if (filters?.subscription_start_date_to) {
  params.append(
    "subscription_start_date_to",
    filters.subscription_start_date_to
  );
}

if (filters?.trial_end_date_from) {
  params.append(
    "trial_end_date_from",
    filters.trial_end_date_from
  );
}

if (filters?.trial_end_date_to) {
  params.append(
    "trial_end_date_to",
    filters.trial_end_date_to
  );
}

if (filters?.subscription_start_date_from) {
  params.append(
    "subscription_start_date_from",
    filters.subscription_start_date_from
  );
}

if (filters?.subscription_start_date_to) {
  params.append(
    "subscription_start_date_to",
    filters.subscription_start_date_to
  );
}
  fetch(`${BASE_URL}/company-admins?${params.toString()}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  })
    .then((res) => res.json())
    .then((data) => {
      if (data?.data?.company_admins) {
        const valid = data.data.company_admins
          .filter((c) => c.latitude && c.longitude)
          .map((c) => ({ ...c, subscription_status: "trial" }));

        setClients(valid);
      }
    })
    .catch(console.error)
    .finally(() => setLoading(false));
}, [token, filters, page, limit,BASE_URL,search]);

const [fullMapOpen, setFullMapOpen] = useState(false);

  // Filter clients based on selectedClientId
  const filteredClients = selectedClientId
    ? clients.filter((c) => c.id === selectedClientId)
    : clients;



    useEffect(() => {
  if (!isLoaded || !mapRef.current || filteredClients.length === 0) return;

  const bounds = new window.google.maps.LatLngBounds();

  filteredClients.forEach((c) => {
    if (c.latitude && c.longitude) {
      bounds.extend({
        lat: parseFloat(c.latitude),
        lng: parseFloat(c.longitude),
      });
    }
  });

  setTimeout(() => {
    if (!bounds.isEmpty()) {
      mapRef.current.fitBounds(bounds);
    }
  }, 300);
}, [filteredClients, isLoaded]);
useEffect(() => {
  if (!mapRef.current) return;

  setTimeout(() => {
    window.google.maps.event.trigger(mapRef.current, "resize");
  }, 300);
}, [filteredClients, fullMapOpen]);
  return (
    <>
    <div
      style={{
        height: "55vh",
        width: "100%",
        position: "relative",
        borderRadius: "12px",
        overflow: "hidden", // prevents scrollbar
      }}
    >
      {/* Clear filter button - visible only when a client is selected */}
      {selectedClientId && (
        <Box
          sx={{
            position: "absolute",
            top: 32,
           right: 12,
            zIndex: 2000,
            backgroundColor: "#fff",
            borderRadius: "6px",
            padding: "4px 8px",
            display: "flex",
            alignItems: "center",
            gap: 1,
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            cursor: "pointer",
            fontFamily: "Poppins, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            color: "#333",
          }}
          onClick={() => onClearClientId && onClearClientId()}
        >
       
          <CloseIcon sx={{ fontSize: 18 }} />
        </Box>
      )}

      {/* Loader overlay */}
      {loading && (
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1000,
            backgroundColor: "rgba(255,255,255,0.7)",
            borderRadius: "10px",
            padding: "20px",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      )}

    {isLoaded && (
  <GoogleMap
 center={{ lat: 37.0902, lng: -95.7129 }} // USA
zoom={4}
    mapContainerStyle={{ height: "100%", width: "100%" }}
    onLoad={(map) => (mapRef.current = map)}
  >
    {filteredClients.map((client) =>
      client.latitude && client.longitude ? (
        <Marker
          key={client.id}
          position={{
            lat: parseFloat(client.latitude),
            lng: parseFloat(client.longitude),
          }}
          icon={getStatusIcon(client.status)}
          onClick={() => setSelectedMarker(client)}
        />
      ) : null
    )}

    {selectedMarker && (
      <InfoWindow
        position={{
          lat: parseFloat(selectedMarker.latitude),
          lng: parseFloat(selectedMarker.longitude),
        }}
        onCloseClick={() => setSelectedMarker(null)}
      >
        <div
          style={{
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "8px 12px",
            boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
            minWidth: "200px",
            fontFamily: "Poppins, sans-serif",
            fontSize: "12px",
          }}
        >
          <strong>{selectedMarker.company_name || "N/A"}</strong>
          <br />
          {selectedMarker.email}
          <br />
          {selectedMarker.country}
        </div>
      </InfoWindow>
    )}
  </GoogleMap>
)}

      </div>
      <p style={{textAlign:"center",marginTop:"10px"}}>
 {t("onlyValidCoordinates")}
</p>
             <CustomButton
   onClick={() => setFullMapOpen(true)}
    label={
      <>
        {t("fullMap")}
      
      </>
    }
    size="small"
    sx={{
      position: "absolute",
      top: 12,
      right: 12,
      py: 0.5,
      height: 28,
      zIndex: 1000,
      fontSize: "12px",
      borderRadius: "6px",
    }}
  />
  {fullMapOpen && (
  <Box
    sx={{
      position: "fixed",
      inset: 0,
      backgroundColor: "#fff",
      zIndex: 2000,
    }}
  >
    {/* Close button */}
    <Box
      onClick={() => setFullMapOpen(false)}
      sx={{
        position: "absolute",
        top: 16,
        right: 16,
        zIndex: 2100,
        width: 36,
        height: 36,
        borderRadius: "50%",
        backgroundColor: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
        fontSize: 18,
        fontWeight: 600,
      }}
    >
      ✕
    </Box>

{isLoaded && (
  <GoogleMap
    center={{ lat: 37.0902, lng: -95.7129 }} // USA
zoom={4}
    mapContainerStyle={{ height: "100%", width: "100%" }}
    onLoad={(map) => (mapRef.current = map)}
  >
    {filteredClients.map((client) =>
      client.latitude && client.longitude ? (
        <Marker
          key={client.id}
          position={{
            lat: parseFloat(client.latitude),
            lng: parseFloat(client.longitude),
          }}
          icon={getStatusIcon(client.status)}
          onClick={() => setSelectedMarker(client)}
        />
      ) : null
    )}

    {selectedMarker && (
      <InfoWindow
        position={{
          lat: parseFloat(selectedMarker.latitude),
          lng: parseFloat(selectedMarker.longitude),
        }}
        onCloseClick={() => setSelectedMarker(null)}
      >
        <div
          style={{
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "8px 12px",
            boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
            minWidth: "200px",
            fontFamily: "Poppins, sans-serif",
            fontSize: "12px",
          }}
        >
          <strong>{selectedMarker.company_name || "N/A"}</strong>
          <br />
          {selectedMarker.email}
          <br />
          {selectedMarker.country}
        </div>
      </InfoWindow>
    )}
  </GoogleMap>
)}
  </Box>
)}

    </>
  );
};



export default TrialClientsPins;
